import {CircularProgress, styled} from '@mui/material';

export const ContractsSpinner = styled(CircularProgress)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
